import { ITableRowProps } from "../../../oversight-core/interfaces/table-row-props";
import styles from "./site-error-log-table-row.module.scss";

const SiteErrorLogTableRow = (props: ITableRowProps) => {
  const { data, cellWidths = [], isActive, onClick } = props;

  return (
    <div className={styles.row}>
      {data.map((item, index) => {
        const widthStyle = cellWidths[index]
          ? {
              width:
                typeof cellWidths[index] === "number"
                  ? `${cellWidths[index]}px`
                  : cellWidths[index],
              minWidth: "100%",
            }
          : {};

        const isSecondLast = index === data.length - 2;
        const isLastFourColumns = index >= 1;

        return (
          <div
            className={`${styles["row-cell"]} h-100 p-2 ${
              isSecondLast ? styles["gap-right"] : ""
            } ${
              isLastFourColumns
                ? `${isActive ? `bg-red-2 text-white` : `bg-background-6`} ${
                    onClick ? `cursor-pointer` : ``
                  }`
                : ""
            } ${index === 1 ? styles["rounded-second"] : ""} ${
              index === data.length - 1 ? styles["rounded-last"] : ""
            }`}
            style={widthStyle}
            key={index}
            onClick={() => {
              if (isLastFourColumns) {
                onClick?.();
              }
            }}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};

export default SiteErrorLogTableRow;
